import { UserDTO } from '@/types/other';
import { upperCase } from './strings/strings.utils';

export default function getUserUsername(
  user: UserDTO | null | undefined,
  isLoading: boolean
) {
  if (isLoading && !user) {
    return '...';
  }
  if (!isLoading && user) {
    if (user.firstName && user.lastName) {
      return `${upperCase(user.firstName)} ${upperCase(user.lastName)}`;
    }
    if (user.firstName) {
      return upperCase(user.firstName);
    }
    if (user.lastName) {
      return upperCase(user.lastName);
    }
    if (user.name) {
      return upperCase(user.name);
    }
  }
  return 'user';
}
